import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'

import styles from './index.module.css'
import 'react-circular-progressbar/dist/styles.css'

export default function Circular() {
  const { beginTime, playingTimer, endTime } = useSelector(state => state.test)
  const [percent, setPercent] = useState(0)
  const timerId = useRef()

  useEffect(() => {
    clearInterval(timerId.current)
    if (playingTimer) {
      timerId.current = setInterval(() => {
        const delta = new Date() - beginTime
        if (delta > 10000) {
          setPercent(1)
          clearInterval(timerId.current)
        }
        if (delta > 500) {
          setPercent((delta - 500) / 7000)
        }
      }, 20)
    } else {
      timerId.current = setInterval(() => {
        const delta = 200 - (new Date() - endTime)
        if (delta > 200) {
          setPercent(0)
          clearInterval(timerId.current)
        }
        setPercent(percent * (delta / 200))
      }, 20)
    }
    return () => {
      clearInterval(timerId.current)
    }
    //eslint-disable-next-line
  }, [beginTime, playingTimer, endTime])

  return (
    <div className={styles.cntr}>
      <CircularProgressbar
        value={percent}
        maxValue={1}
        styles={buildStyles({
          pathTransitionDuration: 0,
          pathColor: percent >= 1 ? '#F23E3E' : '#124EE6',
          trailColor: 'white'
        })}
      />
    </div>
  )
}
